import Info from "../../img/icons/info.svg?react";
import Status from "../../img/icons/status.svg?react";
import { ValidCopnr } from "../../utils/validCopnr";
import { infoIcon, statusIconVariants } from "./elementStatus.css";
import { ElementStatusProps, StatusInfoProps } from "./types";

const StatusInfo = ({ copnr }: StatusInfoProps) => (
  <Status
    className={
      copnr !== null ? statusIconVariants[copnr] : statusIconVariants.default
    }
    aria-hidden
  />
);

const ElementStatus = ({ element }: ElementStatusProps) => {
  if (element?.news) {
    return (
      <StatusInfo copnr={element.chance_of_playing_next_round as ValidCopnr} />
    );
  }
  return (
    <span>
      <Info className={infoIcon} aria-hidden />
    </span>
  );
};

export default ElementStatus;
